<template>
  <div class="wrapper">
     <div class="item" @click="linkTo('myNoticeYj?type=2')">
       <div class="left">
         <img src="./../../assets/images/myNotice/notice_refund.png" alt class="back" />
         <span>退款消息</span>
       </div>
       <div class="right">
         <!-- <div class="radius">!</div> -->
         <img src="./../../assets/images/index/img_back.png" alt class="back" />
       </div>
     </div>
     <div class="item" @click="toYunService()">
       <div class="left">
         <img src="./../../assets/images/myNotice/notice_service.png" alt class="back" />
         <span>客服消息</span>
       </div>
       <div class="right">
         <div class="radius">!</div>
         <img src="./../../assets/images/index/img_back.png" alt class="back" />
       </div>
     </div>
  </div>
</template>

<script>
import weChatShareApi from "../../assets/js/weChatShare";
export default {
  components: {},
  props: {},
  mixins: [weChatShareApi],
  data() {
    return {
      yjNum: 0,
      info:{},
    }
  },
  methods: {
    toYunService() {
      let url = `https://kefu.kjyoumi.com/api/mobileweb/home?channel_id=34483&channel_key=34483zkeq&wechatapp_id=345097&key=76967s450&openid=${this.userInfo.nbr}&nickName=${encodeURIComponent(this.info.nick_name)}&avatarUrl=${encodeURIComponent(this.info.head_pic)}&mobile=${this.info.phone_no||''}`
      let u = navigator.userAgent
      let isandroid = u.indexOf('android') > -1 || u.indexOf('adr') > -1;
      if(isandroid) url=url+'&isvivo=1'
      // window.open(url) 
      this.$router.push({
        path: "/iframe",
        query: {
          title: encodeURIComponent('在线客服'),
          url: encodeURIComponent(url),
        },
      });
    },
    linkTo(url){
      this.$router.push({path:'/'+ url,query:{supNbr:this.userInfo.nbr}});
    },
    getNoticeYj() {
      this.$commonPost({
        jydm: "flow_70206",
        flow_70206: {
          user_nbr: this.userInfo.nbr,
        },
      })
        .then((resp) => {
          if (resp.resp_code == 0 && resp.resp_result == 0) {
            this.yjNum = resp.total_rows
          } else {
            this.$toast({
              message: resp.resp_msg,
              duration: 2000,
            });
          }
        })
        .catch((err) => {
          this.$toast({
            message: err.message,
            duration: 2000,
          });
        });
    },
    getUserInfo(){
      this.$commonPost({
        jydm: "flow_10003",
        flow_10003: {
          user_nbr: this.userInfo.nbr,
        },
      })
        .then((resp) => {
          this.info = resp;
        })
        .catch((err) => {
          this.$toast({
            message: err.message,
            duration: 2000,
          });
        });
    },
  },
  mounted() {
    document.title = '我的消息'
    this.getNoticeYj()
    this.getUserInfo()
  },
}
</script>

<style scoped lang='less'>
.wrapper{
  width: 100%;
  min-height: 100vh;
  background: #f5f5f5;
  padding-top: 0.01rem;
  box-sizing: border-box;
}
.topHead{
  width: 100%;
  height: 1.36rem;
  background: #fff;
  display: flex;
  align-items: center;
  padding: 0 .24rem;
  box-sizing: border-box;
  justify-content: space-between;
}
.pic{
  width: .96rem;
  height: .96rem;
  border-radius: 50%;
  margin-right: .29rem;
}
.topHead span{
  font-size: .3rem;
  color: #333333;
  font-weight: 500;
}
.topHead .back{
  width: 0.44rem;
  height: 0.44rem;
}
.item{
  height: .98rem;
  width: 100%;
  background: #fff;
  display: flex;
  align-items: center;
  padding: 0 .24rem;
  box-sizing: border-box;
  justify-content: space-between;
  margin-top: 0.1rem;
  .left{
    display: flex;
    align-items: center;
    img{
      width: 0.68rem;
      height: 0.68rem;
      margin-right: .2rem;
    }
  }
  span{
    font-size: .3rem;
    color: #333;
    font-weight: 500;
  }
  input{
    font-size: .3rem;
    color: #333;
    font-weight: 500;
    border: none;
    flex: 1;
    margin-left: .2rem;
    text-align: right;
  }
  .right{
    display: flex;
    align-items: center;
    .radius{
      width: 0.34rem;
      height: 0.34rem;
      background: #FF2626;
      margin-right: 0.02rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.2rem;
      color: #fff;
      border-radius: 50%;
      padding: 0 0.01rem;
    }
  }
  .back{
    width: 0.44rem;
    height: 0.44rem;
  }
}
.btn{
  position: absolute;
  bottom: .32rem;
  left: 50%;
  transform: translateX(-50%);
  width: 6.88rem;
  height: 0.88rem;
  border-radius: .04rem;
  background: #FF3B30;
  display: flex;
  justify-content: center;
  align-items: center;
  span{
    font-size: 0.3rem;
    color: #fff;
    font-weight: 500;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/index/myNotice.vue